import '../../sass/blocks/text-rollovers.scss';

import Expandable from '../classes/Expandable';
import { isTouchEnabled } from '../common/helpers';

(() => {
    const $textRollovers = document.querySelectorAll('.text-rollovers');

    if (!$textRollovers) return;

    $textRollovers.forEach($textRollovers => {
        const $textRolloverButtons = $textRollovers.querySelectorAll('.text-rollover');
        const $textRolloverInners = $textRollovers.querySelectorAll('.text-rollover__inner');

        const initTextRollovers = () => {
            if (!$textRolloverButtons) return;

            let expandables = [];

            $textRolloverButtons.forEach($textRolloverButton => {
                const $expandable = $textRolloverButton.querySelector('.text-rollover__expandable');
                const $textRolloverIcon = $textRolloverButton.querySelector('.text-rollover__icon');

                if (!$expandable) return;

                const expandable = new Expandable($expandable);

                if (!expandable) return;

                expandables.push(expandable);

                $textRolloverButton.addEventListener('click', () => {
                    if (!isTouchEnabled()) return;

                    expandable.toggle();
                });

                $textRolloverButton.addEventListener('mouseenter', () => {
                    if (expandable.isOpen || isTouchEnabled()) return;

                    expandable.open();
                });

                $textRolloverButton.addEventListener('mouseleave', () => {
                    if (!expandable.isOpen || isTouchEnabled()) return;

                    expandable.close();
                });

                $textRolloverButton.addEventListener('expandableopen', () => {
                    if (!$textRolloverIcon) return;

                    $textRolloverIcon.classList.add('text-rollover__icon--minimise');
                });

                $textRolloverButton.addEventListener('expandableclose', () => {
                    if (!$textRolloverIcon) return;

                    $textRolloverIcon.classList.remove('text-rollover__icon--minimise');
                });
            });
        };

        const setTextRolloverHeights = () => {
            if (!$textRolloverInners) return;

            let setHeight = null;

            $textRolloverInners.forEach($textRolloverInner => {
                $textRolloverInner.style.minHeight = '';
            });

            if (window.innerWidth < 600) return;

            $textRolloverInners.forEach($textRolloverInner => {
                const $top = $textRolloverInner.querySelector('.text-rollover__top');
                const $text = $textRolloverInner.querySelector('.text-rollover__text');

                if (!$top || !$text) return;

                const thisHeight = $top.offsetHeight + $text.offsetHeight;

                if (!setHeight || thisHeight > setHeight) { 
                    setHeight = thisHeight;
                }
            });

            $textRolloverInners.forEach($textRolloverInner => {
                if (!setHeight) return;

                $textRolloverInner.style.minHeight = `${setHeight}px`;
            });
        };

        window.addEventListener('resize', setTextRolloverHeights);

        initTextRollovers();
        setTextRolloverHeights();
    });
})();
